import { render, staticRenderFns } from "./maintainSection.vue?vue&type=template&id=04d2fa06&"
import script from "./maintainSection.vue?vue&type=script&lang=js&"
export * from "./maintainSection.vue?vue&type=script&lang=js&"
import style0 from "./maintainSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports